<template>
  <div>
    <select v-model="selected" :disabled="disabled">
      <option :value="null">{{ placeholder }}</option>
      <slot></slot>
    </select>
  </div>
</template>

<script>
import { store } from "@/store/scene.js";
export default {
  name: "Select",
  props: ["placeholder", "prop", "disabled"],
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal !== oldVal) store[this.prop] = this.selected;
    },
  },
};
</script>

<style scoped>
select {
  width: 30rem;
  height: 4rem;
  padding: 1rem;
  appearance: none;
  background-image: url(/svg/arrow_down.svg);
  background-repeat: no-repeat;
  background-position: calc(100% - 1rem) 50%;
  cursor: pointer;
}
</style>